export default {
    label_task:{
        en:"Dealers Stocks",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Dealer Stocks",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Dealer Stocks",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Dealer Stocks",
        bn:'ব্যবহারকারীর বিবরণ'
    },

}